import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from "./components/ContactUs";
import BlogList from "./components/BlogList";
import BlogDetail from "./components/BlogDetail";
import CaseStudies from "./components/CaseSudies";
import CaseStudyDetail from "./components/CaseStudyDetail";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* <App /> */}
        <Route path="/" element={<App />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="blog" element={<BlogList />} />
        <Route path="blog/:title" element={<BlogDetail />} />
        <Route path="case-studies" element={<CaseStudies />} />
        <Route path="case-studies/:title" element={<CaseStudyDetail />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
